import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../../../store/store.ts';
import { TmRisk } from '../../models/tmRisk.ts';

interface TmRiskState {
  tmRisks: TmRisk[];
  selectedTmRisk: TmRisk | null;
}

const initialState: TmRiskState = {
  tmRisks: [],
  selectedTmRisk: null,
};

const tmRiskSlice = createSlice({
  name: 'tmRisk',
  initialState,
  reducers: {
    setTmRisks(state, action: PayloadAction<TmRisk[]>) {
      state.tmRisks = action.payload;
    },
    addTmRisk(state, action: PayloadAction<TmRisk>) {
      state.tmRisks.push(action.payload);
    },
    updateTmRisk(state, action: PayloadAction<TmRisk>) {
      const index = state.tmRisks.findIndex((r: TmRisk) => r.id === action.payload.id);
      if (index !== -1) state.tmRisks[index] = action.payload;
    },
    removeTmRisk(state, action: PayloadAction<number>) {
      state.tmRisks = state.tmRisks.filter((r: TmRisk) => r.id !== action.payload);
    },
    setSelectedTmRisk(state, action: PayloadAction<TmRisk | null>) {
      state.selectedTmRisk = action.payload;
    },
  },
});

export const { setTmRisks, addTmRisk, updateTmRisk, removeTmRisk, setSelectedTmRisk } = tmRiskSlice.actions;
export const selectTmRisks = (state: RootState) => state.tmRisk.tmRisks;
export const selectSelectedTmRisk = (state: RootState) => state.tmRisk.selectedTmRisk;
export default tmRiskSlice.reducer;

